import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import devicesSlices, { type DevicesSlices } from './slices';

const devtoolsInstance = devtools(devicesSlices, { name: 'useDevicesStore' });

const useDevicesStore = create<DevicesSlices, [['zustand/devtools', never]]>(devtoolsInstance);

export default useDevicesStore;
